angular.module('leanlaw').filter("exclude", function () {
  return function (list, exclusions, prop) {
    return list.filter(item => {
      if (prop) {
        return !exclusions.find(e => e[prop] == item[prop]);
      }
      return !exclusions.find(e => e == item);
    });
  };
});